import React, { useEffect, useRef, useState, useCallback } from "react";
import { toast, ToastContainer } from "react-toastify";
import MaterialReactTable from "material-react-table";
import { fetchProduit } from "../../Redux/produitReduce";
import Select from "react-select";
import { fetchGrossisteSite } from "../../Redux/grossisteReduce";
import { commandeAddedList, verifCmd, getNumCommandGros } from "../../Redux/commandeReduce";
import { verification } from "../../Redux/usersReduce";
import { Button, Card, Form, Container, Row, Col } from "react-bootstrap";
import { useDispatch } from "react-redux";
import jwt_decode from "jwt-decode";
import { t } from "react-multi-lang";
import Swal from 'sweetalert2';
import { MRT_Localization_FR } from "material-react-table/locales/fr";
import { MRT_Localization_EN } from "material-react-table/locales/en";

function AddCommandeListProduit({ obj, client }) {
  let lang = window.localStorage.getItem("lang");
  const dispatch = useDispatch();
  var token = localStorage.getItem("x-access-token");
  var decoded = jwt_decode(token);
  const idUser = obj.user.id_role == 6 ? obj.user.id_grossiste : null;

  const notify = (type, msg) => {
    if (type === 1)
      toast.success(<strong>{msg}</strong>);
    else
      toast.error(<strong>{msg}</strong>);
  }




  const inputRefs = useRef([]);
  const [focusedIndex, setFocusedIndex] = useState(null);
  const handleKeyDown = (event, rowIndex) => {
    if (event.key === "Enter" || event.key === "Tab") {
      event.preventDefault();

      const nextIndex = parseInt(rowIndex) + 1;
      console.log(nextIndex)
      if (inputRefs.current[nextIndex]) {
        console.log(inputRefs.current[nextIndex])
        inputRefs.current[nextIndex].focus();
        setFocusedIndex(nextIndex);
      }
    }
  };

  const handleFocus = (index) => {
    setFocusedIndex(index);
  };

  const saveTableCalled = useRef(false);
  const [entities, setEntities] = useState([]);
  const rowsPerPageOptions = [10, 25, 50, 100, { label: t("all"), value: entities.length }];
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [save, setSave] = useState(false);
  const [numCmd, setNumCmd] = useState(null);
  const [total, setTotal] = useState(0);
  //date Auj
  var currentDate = new Date();
  var year = currentDate.getFullYear();
  var month = (currentDate.getMonth() + 1).toString().padStart(2, '0');
  var day = currentDate.getDate().toString().padStart(2, '0');
  var formattedDate = year + '-' + month + '-' + day;
  const [entitiesEntete, setEntitiesEntete] = useState([{ Date: formattedDate, id_grossiste: idUser, Grossiste: null, Numero: null }]);
  const [valeurZero, setValeurZero] = useState(0);
  const [entitiesZero, setEntitiesZero] = useState([]);
  const [resteZero, setResteZero] = useState(0);
  const [entitiesReste, setEntitiesReste] = useState([]);
  //Produit
  const [produitSelect, setProduitSelect] = React.useState([]);
  const [loader, setLoader] = useState(true);
  const [remise_industrie3, setRemise_industrie3] = useState(obj.user.id_role == 6 ? obj.user.remise_industrie3 : 0);
  const [remise_industrie2, setRemise_industrie2] = useState(obj.user.id_role == 6 ? obj.user.remise_industrie2 : 0);
  const [fourSelected, setFourSelected] = React.useState(null);
  const [optionFour, setOptionFour] = React.useState([
    {
      value: "",
      label: t("Wholesaler"),
      isDisabled: true,
    },
  ]);


  //get grossiste
  const getGrossiste = useCallback(async () => {
    var grossiste = await dispatch(fetchGrossisteSite({client}));
    var entities = grossiste.payload;
    var arrayOption = [];
    entities.forEach((e) => {
      arrayOption.push({ value: e.id_grossiste, label: e.raison_sociale, remise_industrie3: e.grossistes?.remise_industrie3, remise_industrie2:  e.grossistes?.remise_industrie2 })
    });
    setOptionFour(arrayOption);
  }, [dispatch]);

  const handleRowsPerPageChange = (event) => {
    setRowsPerPage(event.target.value);
  };
  const getNumCmd = useCallback(async (idUser) => {
    // Get the last command number for this user
    const num = await dispatch(getNumCommandGros({ id_grossiste: idUser }));

    const now = new Date();
    const currentYear = now.getFullYear().toString().slice(-2); // e.g., "25"
    const currentMonth = (now.getMonth() + 1).toString().padStart(2, "0"); // e.g., "09"

    let formattedNum = '';

    if (!num.payload.num) {
      // No existing number → start at 001
      formattedNum = `CD-${currentYear}-${currentMonth}-001`;
    } else {
      // Split last number: "CD-25-09-007"
      const parts = num.payload.num.split("-");
      const existingYear = parts[1];
      const existingMonth = parts[2];
      const lastIncrement = parseInt(parts[3]);

      // Increment if same month & year, else reset
      const newIncrement =
        existingYear === currentYear && existingMonth === currentMonth
          ? lastIncrement + 1
          : 1;

      formattedNum = `CD-${currentYear}-${currentMonth}-${newIncrement
        .toString()
        .padStart(3, "0")}`;
    }

    // Update state
    setNumCmd(formattedNum);

    setEntitiesEntete(prev => {
      if (!prev || prev.length === 0) return [{ Numero: formattedNum }]; // create first row if empty
      const updated = [...prev];
      updated[0] = { ...updated[0], Numero: formattedNum }; // update existing first row
      return updated;
    });


  }, [dispatch, entitiesEntete]);

  //get Produit
  const getproduit = useCallback(async (client) => {
    var type = await dispatch(fetchProduit({ client }));

    var list = type.payload;
    var arrayOption = [];
    list.forEach((e, index) => {
      if (e.commerce == 1)
        arrayOption.push({
          index: index,
          idProduit: e.id,
          designation: e.Designation_1,
          code: e.Code_PCT,
          Quantite: 0,
          total: 0,
          code_article: e.Code_article,
          cartonnage: e.Coefficient_UC,
          id_site: e.id_site,
          reste: null,
          style: null,
          nb: 0,
          tag: e.tag,
          type: e.type,
          Remise: e.Remise == 1
            ? client === "/medis"
              ? remise_industrie2
              : remise_industrie3
            : 0,
          prix: parseFloat(e.Prix).toFixed(3)
        });
    });
    setEntities(arrayOption);
    setLoader(false)
  }, [dispatch]);

  function deleteLigne(nb) {
    if (entities.length > 1) {
      var filtered = produitSelect.filter(function (value, index, arr) {
        return index !== parseInt(nb);
      });
      setProduitSelect(filtered);
      var filtered = entities.filter(function (value, index, arr) {
        return index !== parseInt(nb);
      });

      calculateTotalSum(filtered)
      setEntities(filtered);
      notify(1, t("supprimer_succes"));
    } else {
      notify(2, t("contient_ligne"));
    }
  }


  const saveTable = useCallback(
    async (entities, entitiesEntete, total) => {

      // Vérifications initiales
      let verif = true;
      let verifReste = true;

      if (entities.length > 0) {
        entities.forEach((data) => {
          if (data.idProduit === null) verif = false;
          if (isNaN(data.Quantite)) verif = false;
          if (data.tag === 1 && data.reste > 0) verifReste = false;
        });
      } else {
        verif = false;
      }

      // Vérification commande existante
      const verifCmdD = await dispatch(
        verifCmd({
          numero: entitiesEntete[0].Numero,
          grossiste: entitiesEntete[0].id_grossiste
        })
      );
      const testT = await verifCmdD.payload;

      // Early returns pour les erreurs
      if (!verifReste) {
        notify(2, "Le produit n’est recommandable que par multiple de carton");
        return;
      }
      if (!verif) {
        notify(2, t("erreur"));
        return;
      }
      if (testT === true) {
        notify(2, t("cmd_deja"));
        return;
      }
      if (entitiesEntete[0].id_grossiste === null) {
        notify(2, t("Grossiste.obligatoire"));
        return;
      }

      // Vérification si plusieurs types
      let divise = 0;
      const types = [...new Set(entities.filter(e => parseInt(e.Quantite) > 0).map(e => e.type))];
      console.log(types)
      if (types.length > 1) {
        const result = await Swal.fire({
          title: 'Division Commande',
          text: "La commande contient plusieurs types (AMM et AMC). Voulez-vous diviser la commande ?",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Oui, diviser',
          cancelButtonText: 'Non',
        });

        if (result.isConfirmed) {
          divise = 1; 
        }
      }

      // Empêcher double clic
      if (saveTableCalled.current) return;
      saveTableCalled.current = true;
      setSave(true);

      // Dispatch de l'ajout
      dispatch(
        commandeAddedList({
          type_insert: 1,
          divise,
          Montant: total,
          ligneCommande: entities,
          enteteCmd: entitiesEntete
        })
      ).then((e) => {
        if (e.payload === true) {
          notify(1, t("add_txt"));
          setTimeout(() => {
            window.location.replace(client + "/commandeList");
          }, 1000);
        } else {
          setSave(false);
          saveTableCalled.current = false;
          notify(2, t("erreur"));
        }
      });

    },
    [dispatch]
  );


  //   async (entities, entitiesEntete, total) => {

  //     var verif = true;
  //     var verifReste = true;
  //     if (entities.length > 0) {
  //       entities.forEach((data) => {
  //         if (data.idProduit === null) verif = false;
  //       });
  //       entities.forEach((data) => {
  //         if (isNaN(data.Quantite)) verif = false;
  //       });
  //       entities.forEach((data) => {
  //         if ((data.tag == 1) && data.reste > 0) verifReste = false;
  //       });
  //     }
  //     else { verif = false; }
  //     var verifCmdD = await dispatch(
  //       verifCmd({
  //         numero: entitiesEntete[0].Numero,
  //         grossiste: entitiesEntete[0].id_grossiste
  //       })
  //     );
  //     var testT = await verifCmdD.payload;
  //     //setSave(true)
  //     if (verifReste == false) {
  //       notify(2, "Le produit n’est recommandable que par multiple de carton");
  //       return
  //     }
  //     if (verif === false) {
  //       notify(2, t("erreur"));
  //     } else if (testT === true) {
  //       notify(2, t("cmd_deja"));
  //     } else {
  //       if (entitiesEntete[0].id_grossiste !== null) {
  //         if (saveTableCalled.current) return;
  //         saveTableCalled.current = true
  //         setSave(true)
  //         var divise = 0
  //         const types = [...new Set(entities.map(e => e.type))]; // extrait les types uniques
  //         if (types.length > 1) {
  //           const confirmSplit = window.confirm(
  //             "La commande contient plusieurs types (AMM et AMC). Voulez-vous diviser la commande  ?"
  //           );
  //           if (confirmSplit) {
  //             divise = 1
  //           }
  //         }
  //         dispatch(commandeAddedList({ type_insert: 1, divise, Montant: total, ligneCommande: entities, enteteCmd: entitiesEntete })).then((e) => {
  //           if (e.payload === true) {
  //             notify(1, t("add_txt"));
  //             // setTimeout(() => {
  //             //   window.location.replace(client + "/commandeList")
  //             // }, 1000);
  //           } else {
  //             setSave(false)
  //             saveTableCalled.current = false
  //             notify(2, t("erreur"));
  //           }
  //         });
  //       } else {
  //         notify(2, t("Grossiste.obligatoire"));
  //       }
  //     }

  //   },
  //   [dispatch]
  // );
  // const saveTable = useCallback(
  const calculateTotalSum = (entities) => {
    const sum = entities.reduce((acc, curr) => {
      return acc + parseFloat(curr.total || 0); // add total to accumulator, default to 0 if total is undefined
    }, 0); // initial accumulator value is 0

    setTotal(sum);
  };

  const columns = [
    {
      id: "code_pct",
      header: t("code_pct"),
      accessorKey: "code",
      Cell: ({ cell }) => (
        <div>
          {cell.row.original.tag == 1 ? <i style={{ color: "#9C27B0", fontSize: "15px" }} className="fa-solid fa-cube"></i> : null} {cell.getValue()}
        </div>
      ),
    }
    ,
    {
      id: "code",
      header: t("code_article"),
      accessorKey: "code_article",
    },
    {
      id: "designation",
      header: t("designation"),
      accessorKey: "designation",
      Cell: ({ cell }) => {
        return (
          <div id="roleClass" >
            <Form.Group className="desinationProduit">
              <Form.Control
                className="green"
                readOnly
                value={cell.row.original.designation}
                placeholder="Designation"
                type="text"
              />
            </Form.Group>
          </div>
        );
      },
    },
    {
      id: "Remise",
      header: `Remise`,
      accessorKey: "Remise",
    },
    {
      id: "prix",
      header: `${t("prix")} (HT TND)`,
      accessorKey: "prix",
    },
    {
      id: "cartonnage",
      header: `${t("cartonnage")}`,
      accessorKey: "cartonnage",
    },
    {
      id: "quantite",
      header: t("quantite_cmd"),
      accessorKey: "Quantite",
      Cell: ({ cell }) => (
        <Form.Group>
          <Form.Control
            className={cell.row.original.style === "red" ? "redBorder" : "defaultBorder"}
            defaultValue={cell.row.original.Quantite}
            placeholder="Quantite"
            type="number"
            pattern="\d+"
            onBlur={(value) => {
              let e, list;
              if (valeurZero == 0 && resteZero == 0) {
                e = [...entities];
              } else if (valeurZero == 1) {
                e = [...entitiesZero];
                list = [...entities];
              } else {
                e = [...entitiesReste];
                list = [...entities];
              }

              const row = e[cell.row.id];
              let rawQuantite = parseInt(value.target.value.replace(/[^0-9]/g, '')) || 0;



              // Apply rounding if cartonnage > 0 and condition met
              if (row.cartonnage > 0 && rawQuantite / row.cartonnage >= 0.6 && row.tag == 2) {
                rawQuantite = Math.ceil(rawQuantite / row.cartonnage) * row.cartonnage;

                const seuil = row.cartonnage * 0.6;
                row.style = "red";

                notify(2, `Le produit doit être arrondi en caisse pour la quantité sup ${seuil}`);
              }



              row.Quantite = rawQuantite;
              row.nb = row.cartonnage > 0 ? parseInt(rawQuantite / row.cartonnage) : 0;

              if (rawQuantite && rawQuantite < row.cartonnage) {
                row.reste = row.cartonnage - rawQuantite;
              } else if (rawQuantite % row.cartonnage > 0) {
                row.reste = row.cartonnage - (rawQuantite % row.cartonnage);
              } else {
                row.reste = 0;
              }

              // Calculate remise as decimal
              let remiseDecimal = 0;
              if (row.Remise && row.Remise !== 0) {
                remiseDecimal = typeof row.Remise === "number" ? row.Remise : parseFloat(row.Remise);
                if (remiseDecimal > 1) remiseDecimal = remiseDecimal / 100;
              }

              if ((row.tag == 1) && row.reste > 0) {
                row.Quantite += row.reste
                rawQuantite += row.reste
                row.reste = 0
                row.nb += 1
                row.style = "red";
                notify(2, "Le produit n’est recommandable que par multiple de carton");
              }

              // Apply remise discount on total
              row.total = rawQuantite
                ? (row.prix * rawQuantite * (1 - remiseDecimal)).toFixed(3)
                : 0;
              if (list) {
                const idx = row.index;
                list[idx].Remise = row.Remise; // keep remise synced in list
                list[idx].Quantite = rawQuantite;
                list[idx].nb = row.cartonnage > 0 ? parseInt(rawQuantite / row.cartonnage) : 0;

                if (rawQuantite && rawQuantite < row.cartonnage) {
                  list[idx].reste = row.cartonnage - rawQuantite;
                } else if (rawQuantite % row.cartonnage > 0) {
                  list[idx].reste = row.cartonnage - (rawQuantite % row.cartonnage);
                } else {
                  list[idx].reste = 0;
                }

                list[idx].total = rawQuantite
                  ? (list[idx].prix * rawQuantite * (1 - remiseDecimal)).toFixed(3)
                  : 0;

                calculateTotalSum(list);
                setEntities(list);
              }

              if (valeurZero == 0 && resteZero == 0) {
                setEntities(e);
                calculateTotalSum(e);
              } else if (valeurZero == 1) {
                setEntitiesZero(e);
              } else {
                setEntitiesReste(e);
              }
            }
            }

          />
        </Form.Group>
      ),
    }
    ,
    {
      id: "nb",
      header: `${t("nb_carton")}`,
      accessorKey: "nb",
    },
    {
      id: "reste",
      header: `${t("reste")}`,
      accessorKey: "reste",
    },
    {
      id: "prix_total",
      header: `${t("prix_total")} (HT TND)`,
      accessorKey: "total",
    },
    {
      id: "action",
      header: t("action"),
      accessorKey: "id",
      Cell: ({ cell }) => (
        <Button
          id={"idLigneR_" + cell.row.id}
          onClick={() => {
            deleteLigne(cell.row.id);
          }}
          variant="danger"
          size="sm"
          className="text-danger btn-link delete"
        >
          <i className="fas fa-times"></i>
        </Button>
      ),
    },
  ];

  function getProduitZero(list, valeurZero) {
    const filteredList = list.filter(item => {
      if (valeurZero === 1) {
        return item.Quantite === 0;
      } else {
        return true;
      }
    });
    setEntitiesZero(filteredList)
  }

  function getProduitReste(list, resteZero) {
    const filteredList = list.filter(item => {
      if (resteZero === 1) {
        return item.reste != 0 && item.reste != null;
      } else {
        return true;
      }
    });
    setEntitiesReste(filteredList)
  }

  const renderRowProps = (rowData) => {
    if (rowData.row.original.reste > 0) {
      return { className: 'reste-warning' };
    } else if (rowData.row.original.Quantite > 0) {
      return { className: 'quantite-success' };
    }
    return {};
  };

  function ListTable({ list, valeurZero, entitiesZero, resteZero, entitiesReste, loader }) {
    return (
      <MaterialReactTable
        state={{ isLoading: loader }}
        columns={columns}
        data={valeurZero == 0 && resteZero == 0 ? list : valeurZero == 1 ? entitiesZero : resteZero == 1 ? entitiesReste : list}
        enableColumnActions={true}
        enableColumnFilters={true}
        enablePagination={true}
        enableSorting={true}
        enableBottomToolbar={true}
        enableTopToolbar={true}
        muiTableBodyRowProps={renderRowProps}
        displayColumnDefOptions={{
          'mrt-row-numbers': {
            size: 10,
          },
          'mrt-row-expand': {
            size: 10,
          },
        }}
        enableColumnFilterModes
        initialState={{
          columnVisibility: { description: false },
          density: 'compact',
          showGlobalFilter: true,
          pagination: {
            pageSize: rowsPerPage,
          },
        }}

        muiSearchTextFieldProps={{
          placeholder: t("search"),
          sx: { minWidth: '18rem' },
          variant: 'outlined',
        }}
        localization={
          lang === "fr"
            ? MRT_Localization_FR
            : MRT_Localization_EN
        }
        muiTablePaginationProps={{
          rowsPerPage: rowsPerPage,
          rowsPerPageOptions: rowsPerPageOptions,
          onRowsPerPageChange: handleRowsPerPageChange,
        }}
      />
    );
  }

  const verifToken = useCallback(async () => {
    try {
      dispatch(verification()).then(e => {
        if (e.payload === false) {
          localStorage.clear();
          window.location.replace("/login");
        }
      })
    } catch (error) {
      localStorage.clear();
      window.location.replace("/login");
    }

  }, [dispatch]);

  useEffect(() => {
    getNumCmd(idUser)
    verifToken()
    if(obj.user.id_role != 6 )getGrossiste();
    getproduit(client)
  }, []);

  useEffect(() => {
    inputRefs.current = inputRefs.current.slice(0, entities.length);
  }, [entities.length]);

  return (
    <>
      <Container fluid>
        <ToastContainer />
        <Row>
          <Col md="12">
            <Button
              id="saveBL"
              className="btn-wd btn-outline mr-1 float-left"
              type="button"
              variant="info"
              onClick={() => {
                window.history.back();
              }}
            >
              <span className="btn-label">
                <i className="fas fa-list"></i>
              </span>
              {t('list')}
            </Button>
          </Col>
        </Row>
        <div className="section-image">
          <Card>
            <Card.Header>
              <Card.Title as="h4">{t('new_commande')}</Card.Title>
              <hr></hr>
              <Card.Title as="h4">{t('commande')} N° {numCmd}</Card.Title>
            </Card.Header>
            <Card.Body>
              {obj.user.id_role != 6 && (

                <Select
                  className="react-select"
                  name="Grossiste"
                  placeholder="Grossiste"
                  value={fourSelected}
                  onChange={(v) => {
                    console.log("👉 Test L : nouveau grossiste sélectionné", v); // 🔥 test log

                    setFourSelected(v);
                    var prev = [...entitiesEntete];
                    prev[0].Grossiste = v.label;
                    prev[0].id_grossiste = v.value;
                    prev[0].remise_industrie3 = v.remise_industrie3;
                    prev[0].remise_industrie2 = v.remise_industrie2;

                    setRemise_industrie2(v.remise_industrie2);
                    setRemise_industrie3(v.remise_industrie3);

                    // 🔥 test recalcul remise
                    const updatedEntities = entities.map(e => {
                      let remiseDecimal = 0;
                      let remise = 0
                      remiseDecimal = client === "/medis" ? v.remise_industrie2 : v.remise_industrie3;
                      remise = client === "/medis" ? v.remise_industrie2 : v.remise_industrie3;
                      if (remiseDecimal > 1) remiseDecimal = remiseDecimal / 100;


                      console.log("👉 Test L - recalcul ligne:", e.designation, "ancienne remise:", e.Remise, "nouvelle remise:", remiseDecimal);

                      return {
                        ...e,
                        Remise: remise,
                        total: e.Quantite
                          ? (e.prix * e.Quantite * (1 - remiseDecimal)).toFixed(3)
                          : 0
                      };
                    });
                    calculateTotalSum(updatedEntities)
                    setEntities(updatedEntities);
                    setEntitiesEntete(prev);
                  }}

                  options={optionFour}
                  menuPortalTarget={document.body}
                  styles={{
                    menuPortal: base => ({ ...base, zIndex: 9999 }),
                  }}
                />
              )}

              <h4 className="float-left"><strong>{t('montant_total')}: {total.toFixed(3)} HT TND</strong></h4>

              <Row className="float-right" style={{ width: "50%", margin: "30px 0 15px" }}>
                <Col md="12">
                  <Row>
                    <Col md="6">
                      <Form.Group>
                        <Form.Check>
                          <Form.Check.Label>
                            <Form.Check.Input
                              type="checkbox"
                              checked={resteZero == 1 ? true : false}
                              onChange={(v) => {
                                if (v.target.checked) {
                                  setResteZero(1);
                                  setValeurZero(0)
                                  getProduitReste(entities, 1)
                                }
                                else setResteZero(0)
                              }}
                            ></Form.Check.Input>
                            <span className="form-check-sign"></span>
                            <label>{t('produit_en_vrac')}</label>
                          </Form.Check.Label>
                        </Form.Check>
                      </Form.Group>
                    </Col>
                    <Col md="6">
                      <Form.Group>
                        <Form.Check>
                          <Form.Check.Label>
                            <Form.Check.Input
                              type="checkbox"
                              checked={valeurZero == 1 ? true : false}
                              onChange={(v) => {
                                if (v.target.checked) {
                                  setValeurZero(1);
                                  setResteZero(0)
                                  getProduitZero(entities, 1)
                                }
                                else setValeurZero(0)
                              }}
                            ></Form.Check.Input>
                            <span className="form-check-sign"></span>
                            <label>{t('produit_non_commander')}</label>
                          </Form.Check.Label>
                        </Form.Check>
                      </Form.Group>
                    </Col>
                  </Row>
                </Col>
              </Row>

              <br clear="all"></br>
              <hr></hr>
              {<ListTable loader={loader} list={entities} valeurZero={valeurZero} entitiesZero={entitiesZero} resteZero={resteZero} entitiesReste={entitiesReste} />}
              <br></br>
              <hr></hr>

              <br></br>
              <Col md="12">
                {!save ? <Button
                  id="saveBL"
                  className="btn-wd btn-outline mr-1 float-right"
                  type="button"
                  variant="info"
                  onClick={() =>
                    saveTable(entities, entitiesEntete, total)
                  }
                >
                  <span className="btn-label">
                    <i className="fas fa-check"></i>
                  </span>
                  {t("save_draft")}
                </Button> : ""}

              </Col>
            </Card.Body>
          </Card>


        </div >
      </Container >

    </>
  );
}

export default AddCommandeListProduit;
